import { forwardRef } from 'react';
import PropTypes from 'prop-types';

function PaymentezPaymentTypeButton({ label, description, innerRef }) {
  return (
    <button
      ref={innerRef}
      className="rounded-lg text-lg shadow ring-1 ring-opacity-10 hover:ring-opacity-30 hover:shadow-lg focus:ring-4 focus:ring-green-200 ring-black p-6 border border-transparent focus:border-green-600 bg-white focus:hover:shadow-none"
      type="button"
    >
      <div className="flex items-start space-x-4">
        <svg
          className="w-12 h-12 text-green-400"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
            d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z"
          />
        </svg>
        <div className="flex flex-col text-left space-y-1">
          <h4 className="font-semibold whitespace-nowrap text-xl">{label}</h4>
          <div className="text-gray-500 leading-6">{description}</div>
        </div>
      </div>
    </button>
  );
}

PaymentezPaymentTypeButton.defaultProps = {};

PaymentezPaymentTypeButton.propTypes = {
  label: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
};

const PaymentezPaymentTypeButtonContainer = forwardRef((props, ref) => (
  <PaymentezPaymentTypeButton innerRef={ref} {...props} />
));

PaymentezPaymentTypeButtonContainer.displayName =
  'PaymentezPaymentTypeButtonContainer';

export default PaymentezPaymentTypeButtonContainer;
